"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserSessionProvider = void 0;
var _jsxRuntime = require("react/jsx-runtime");
/** @deprecated UserSessionProvider was moved to @ori-appshell/layouts, this will be removed in the next major release */
const UserSessionProvider = () => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {});
exports.UserSessionProvider = UserSessionProvider;
